module.exports = __webpack_public_path__ + "static/img/close.9507c6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 0